export function resolveHorizontalTabNavigationIndex(
  key: string,
  currentIndex: number,
  itemCount: number,
): number | null {
  if (itemCount <= 0 || currentIndex < 0 || currentIndex >= itemCount) {
    return null;
  }

  if (key === "Home") {
    return 0;
  }

  if (key === "End") {
    return itemCount - 1;
  }

  if (key === "ArrowLeft" || key === "ArrowUp") {
    return (currentIndex - 1 + itemCount) % itemCount;
  }

  if (key === "ArrowRight" || key === "ArrowDown") {
    return (currentIndex + 1) % itemCount;
  }

  return null;
}

export function resolveRovingFocusIndex(
  selectedIndex: number,
  itemCount: number,
): number {
  if (itemCount <= 0) {
    return -1;
  }

  return selectedIndex >= 0 && selectedIndex < itemCount ? selectedIndex : 0;
}
